import API from '@/org-app/api';
import { GET_ATTACHABLE_FEES } from '@/org-app/store/modules/fees/mutation-types';
import { createApiAction } from '@/utils/ActionsUtils';

const actions = {
  getEntityFees: createApiAction(API.instance.getEntityFees, null, 'messages.failedToGetEntityFees'),
  getAttachableFees: createApiAction(
    API.instance.getAttachableFees,
    GET_ATTACHABLE_FEES,
    'messages.failedToGetAttachableFees',
  ),
  getFeatureFees: createApiAction(API.instance.getFeatureFees, null, 'messages.failedToGetFeatureFees'),
};

export default actions;
